const actions = {
  GET_BENEFICIARIES_BY_CLIENT_ID: 'GET_BENEFICIARIES_BY_CLIENT_ID',
  GET_BENEFICIARIES_BY_CLIENT_ID_SUCCESS: 'GET_BENEFICIARIES_BY_CLIENT_ID_SUCCESS',
  GET_BENEFICIARIES_BY_CLIENT_ID_FAILURE: 'GET_BENEFICIARIES_BY_CLIENT_ID_FAILURE',
}

export default actions

export const getBeneficiariesByClientId = (clientId, token) => {
  return {
    type: actions.GET_BENEFICIARIES_BY_CLIENT_ID,
    payload: { clientId, token },
  }
}
